import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";
import CustomTooltip from "../common/CustomTooltip";

const APPROVAL_CONFIG: Record<
  number,
  { label: string; tooltip: string; borderKey: string; bgKey: string }
> = {
  0: {
    label: "Pending",
    tooltip: "Health scores awaiting review",
    borderKey: "W",
    bgKey: "W",
  },
  1: {
    label: "Pending",
    tooltip: "Health scores awaiting review",
    borderKey: "W",
    bgKey: "W",
  },
  2: {
    label: "Hidden",
    tooltip: "All health scores hidden",
    borderKey: "N",
    bgKey: "N",
  },
  3: {
    label: "Partially Approved",
    tooltip: "Some health scores approved",
    borderKey: "W",
    bgKey: "W",
  },
  4: {
    label: "Approved",
    tooltip: "All health scores approved",
    borderKey: "S",
    bgKey: "S",
  },
};

const ScoreApprovalBadge = ({ approval }: { approval?: number }) => {
  const theme: Theme = useTheme();
  if (approval == null) return null;

  const config = APPROVAL_CONFIG[approval];
  if (!config) return null;

  const tokenSet =
    config.borderKey === "N"
      ? theme.colorTokens.N
      : config.borderKey === "W"
      ? theme.colorTokens.W
      : theme.colorTokens.S;

  const dotColor =
    approval === 4
      ? theme.colorTokens.S[70]
      : approval === 3
      ? theme.colorTokens.P[80]
      : approval === 2
      ? theme.colorTokens.N[80]
      : theme.colorTokens.W[70];

  return (
    <div style={{ display: "flex", justifyContent: "flex-start" }}>
      <CustomTooltip message={config.tooltip} customHeight="auto">
        <div
          style={{
            padding: "4px 8px",
            borderRadius: 8,
            border: `1px solid ${dotColor}`,
            backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
            fontFamily: "var(--font-Medium)",
            fontSize: 12,
            width: "fit-content",
            display: "flex",
            alignItems: "center",
            gap: 8,
            color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
          }}
        >
          <div
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: dotColor,
              flexShrink: 0,
            }}
          />
          {config.label}
        </div>
      </CustomTooltip>
    </div>
  );
};

export default ScoreApprovalBadge;
